import React from 'react'
import Header from '../../common/Header'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import CommonHeroSection from '../../common/CommonHeroSection'
import Footer from '../../common/Footer'
import TicketSection from '../../sections/CommonSection/TicketSection'
import organizingSchoolTripsImg from '../../../assets/our-services-img/organizing-school-trip-img.jpg';

const OrganizingSchoolTrips = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Organizing School & College Trips" />
            <CommonBreadcrumb items={["Organizing School & College Trips"]} />
            <TicketSection
                title="Organizing School & College Trips"
                description={[
                    `Though there are miscellaneous options of transportation like flights, cars and many others available for travelling to a place, nothing can beat the rhythmic and less-costly journey of a train. When it's about booking a railway ticket, Sudarshan Holidays is the one-stop solution. Railway ticket booking can be time-consuming if every single detail is not filled with proper information and care. Therefore, it's advisable to take the professional help of an experienced travel agency like us to finish the entire procedure.`,
                    `We are one of the trustworthy travel agencies on which you can rely with 100% trust. At Sudarshan Holidays, we both efficiently book your railway tickets and deliver them to your address with a rapid and assured delivery before your much-awaited Bangalore trip.`,
                    `Mail your legal documents to us or call us to get assured bookings of your required railway tickets.`
                ]}
                image={organizingSchoolTripsImg}
            />
            <Footer />
        </>
    )
}

export default OrganizingSchoolTrips